import {FormField} from '../../../layout/Form'
import {Mod} from '../../../../types'
import React from 'react'

export type FileType = {
	filesize: number // Filesize in Mb
	filetypes: Array<string> // list of accepted filetypes [.pdf,.png]
	label: string
	mod?: Mod<'half' | 'maxwidth' | 'error'>
	multiple: boolean
	name: string
	placeholder: string
	required: boolean
	value: any
	serverErrors?: Array<string>
	onChange?: (file: any) => void
}

export const File: React.FC<FileType> = ({
	filesize,
	filetypes,
	label,
	mod,
	multiple,
	name,
	placeholder,
	required,
	value,
	serverErrors = [],
	onChange: onChangeHandler
}) => {
	return (
		<FormField
			filesize={filesize}
			filetypes={filetypes}
			label={label + (required ? ' (*)' : '')}
			mod={mod}
			multiple={multiple}
			name={name}
			placeholder={placeholder}
			required={required}
			serverErrors={serverErrors}
			type="file"
			value={value}
			onChange={(file: any) => {
				if (onChangeHandler) {
					onChangeHandler(file)
				}
			}}
		/>
	)
}
